import { VehicleProvider } from '@cbgms/api'
import { StepOption } from '../../../context/SelectionContext'
import { useGetBrands } from './useGetBrands'
import { useGetModels } from './useGetModels'
import { useGetTypes } from './useGetTypes'
import { ShopCountry } from '@cbgms/base/shop-id'

export const useGetAllSelectionAttributes = (
  currentStep: StepOption,
  provider: VehicleProvider,
  country: ShopCountry,
  brandKey?: string,
  modelKey?: string
) => {
  const { data: brands, isInitialLoading: isLoadingBrands } = useGetBrands(provider, country)
  const { data: models, isInitialLoading: isLoadingModels } = useGetModels(provider, country, brandKey)
  const { data: types, isInitialLoading: isLoadingTypes } = useGetTypes(provider, country, brandKey, modelKey)

  const brandLoading = currentStep === StepOption.BRAND && (isLoadingBrands || !brands)
  const modelLoading = currentStep === StepOption.MODEL && (isLoadingModels || !models)
  const typeLoading = currentStep === StepOption.TYPE && (isLoadingTypes || !types)

  const isLoading = brandLoading || modelLoading || typeLoading

  return {
    isLoading,
    brands,
    models,
    types
  }
}
